const getNotificationLogo = (type) => {
    if (type === null) {
        return 'assets/images/svg/notification-default.svg';
    } else if (type === 'welcome') {
        return 'assets/images/svg/welcome-notification.svg';
    } else if (type === 'info') {
        return 'assets/images/svg/info-notification-v2.svg';
    } else if (type === 'alert') {
        return 'assets/images/svg/alert-notification.svg';
    }
};

export { getNotificationLogo };
